import { VegetationIndexState } from "./types";
export default {
  vegetationIndexAverage: (state: VegetationIndexState) => (uuid: string) => state.vegetationIndexAverageContext.get(uuid) || [],
  vegetationIndexAverageForCropTypeNotConfirmed: (state: VegetationIndexState) => (uuid: string) => state.vegetationIndexAverageForCropTypeNotConfirmedContext.get(uuid) || [],
  vegetationIndexCrop: (state: VegetationIndexState) => (uuid: string) => state.vegetationIndexCropsContext.get(uuid) || [],
};
